import { supabase } from './supabaseClient';

/**
 * Dispara notificação por email (Brevo) via Edge Function Supabase.
 * Falha silenciosamente — o registo na BD já foi guardado.
 *
 * @param {'contact' | 'job_application' | 'newsletter'} type
 * @param {string} id — UUID do registo criado
 */
export async function notifyBrevo(type, id) {
  if (!type || !id) return;

  try {
    const { error } = await supabase.functions.invoke('brevo-notify', {
      body: { type, id },
    });

    if (error) {
      console.warn('[Brevo] notify failed:', error.message);
    }
  } catch (err) {
    console.warn('[Brevo] notify error:', err);
  }
}
